import { FC } from 'react';

import { TipCardContainer } from '@custom-components/InspirationAdviceFilter';
import { Box, Skeleton } from '@sparky';

export const TipCardSkeleton: FC = () => (
  <TipCardContainer backgroundColor="backgroundPrimary" padding="6" borderRadius="m">
    <Skeleton width="100%" height="20px" />
    <Skeleton width="70%" height="20px" />
    <br />
    <Box paddingTop="3" paddingBottom="3">
      <Skeleton width="100%" height="20px" />
      <Skeleton width="100%" height="20px" />
      <Skeleton width="50%" height="20px" />
    </Box>
  </TipCardContainer>
);
